import { getNotifications, selectChatNotifications, selectChatNotificationsMeta } from '../chatSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import useTranslation from 'hooks/useTranslation'
import React, { useRef, useState } from 'react'
import usePopupState from 'hooks/usePopupState'
import SendPhotoPopup from './SendPhotoPopup'
import Notification from './Notification'
import Loading from 'components/Loading'
import BasicPopup from './BasicPopup'
import Error from 'components/Error'

interface NotificationsProps {
  onlyImportantNotifications?: boolean
}

const Notifications: React.FC<NotificationsProps> = ({ onlyImportantNotifications }) => {
  const [isLoading, setLoading] = useState(false)
  const allNotifications = useReduxSelector(selectChatNotifications)
  const meta = useReduxSelector(selectChatNotificationsMeta)
  const notifications = onlyImportantNotifications
    ? allNotifications.filter(notification => notification.type === 'warning')
    : allNotifications

  const listRef = useRef<HTMLDivElement>(null)
  const { popup } = usePopupState<chat.NotificationPopup | undefined>()

  const dispatch = useReduxDispatch()
  const { t } = useTranslation('basic')

  const handleScroll: React.UIEventHandler<HTMLDivElement> = () => {
    if (isLoading) return
    const list = listRef.current
    const pagination = meta?.pagination
    if (!list || !pagination) return
    const { scrollTop, scrollHeight, clientHeight } = list
    if (
      pagination
      && pagination.links.next
      && pagination.count > pagination.current_page
      && scrollHeight - scrollTop - 2 <= clientHeight
    ) {
      setLoading(true)
      dispatch(getNotifications(pagination.links.next)).then(() => {
        setLoading(false)
      })
    }
  }

  return (
    <>
      {popup?.type === 'notificationModal' && <BasicPopup
        {...popup.props}
      />}
      {popup?.type === 'sendPhoto' && <SendPhotoPopup
        {...popup.props}
      />}
      {!onlyImportantNotifications && <h4 className='--secFont'>{t('messages')}</h4>}
      <div
        ref={listRef}
        className='chat__list'
        onScroll={handleScroll}>
        {notifications.length > 0
          ? notifications.map((notification) => <Notification
            key={notification.id}
            {...notification}
          />)
          : <Error text={t('noMessages')} />}
        {isLoading && <div className='list__footer'><Loading /></div>}
        {!isLoading
          && notifications.length > 0
          && !onlyImportantNotifications
          && meta?.pagination?.current_page === meta?.pagination?.total_pages
          && <div className='list__footer'>
            <hr />
            <span className='chat__text'>{t('thatIsAll')}</span>
          </div>}
      </div>
    </>
  )
}

export default Notifications